import { CardLinkTranslation } from "@models/card-link-translation.model";
import { BaseConverter } from "./BaseConverter";
import { CardLinkTranslationDto } from "@dtos/card-link-translation.dto";
import { CardLinkConverter } from "./cardLinkConverter";

export class CardLinkTranslationConverter extends BaseConverter<CardLinkTranslation, CardLinkTranslationDto>{
    private cardLinkConverter = new CardLinkConverter()
    modelToDto(model: CardLinkTranslation): CardLinkTranslationDto {
        return new CardLinkTranslationDto(
            model.id,
            model.title,
            model.distance,
            model.minPrice,
            model.maxPrice,
            model.currency,
            model.locale,
            model.details,
            model.fullAddress,
            model.cardLink? this.cardLinkConverter.modelToDto(model.cardLink): undefined 
        )
    }

    dtoToModel(dto: CardLinkTranslationDto): CardLinkTranslation {
        return new CardLinkTranslation(
            dto.id,
            dto.title,
            dto.distance,
            dto.minPrice,
            dto.maxPrice,
            dto.currency,
            dto.locale,
            dto.details,
            dto.fullAddress,
            dto.cardLink? this.cardLinkConverter.dtoToModel(dto.cardLink): undefined
        )
        
    }
}